import React, { Component } from 'react';
import { Col, Container, Row  } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';


export class Refer extends Component {

    render() {

        return (
            <Row>
                <Col xs="12" lg={{ size: 6, offset: 3 }} id="referral-form-container">
                    <Form action='https://crm.zoho.eu/crm/WebToLeadForm' name='WebToLeads213296000000233009' method='POST' accept-charset='UTF-8'>
                        <div className="referral-form">
                            <input type='text' style={{ display: 'none' }} name='xnQsjsdp' value='0096430e3cbb3fb994f032a3bfd7b6d8d2630e48c1e21ef3b4e5b985accf9d91' />
                            <input type='hidden' name='zc_gad' id='zc_gad' value='' /> 
                            <input type='text' style={{display: 'none'}} name='xmIwtLD' value='c611b63ca15f0f0188b621c0226ba0ccca7adf7c41963e120df59bc5e4b8203c'/> 
                            <input type='text' style={{display: 'none'}} name='actionType' value='TGVhZHM='/>
                            <input type='text' style={{display: 'none'}} name='returnURL' value='https://www.provestor.co.uk'/>

                            <FormGroup>
                              <Label for="firstname">Client's first name *</Label>
                              <Input type="text" name="First Name" id='firstname' required  maxlength='40' />
                            </FormGroup>
                            <FormGroup>
                              <Label for="lastname">Client's last name *</Label>
                              <Input type="text" name="Last Name" id='lastname' required  maxlength='80' />
                            </FormGroup>
                            <FormGroup>
                              <Label for="email">Client's email</Label>
                              <Input type="email" name="Email" id='email'  maxlength='100' />
                            </FormGroup>
                            <FormGroup>
                              <Label for="tel">Client's phone number</Label>
                              <Input type="tel" name="Phone" id='tel'  maxlength='30' />
                            </FormGroup>
                            <FormGroup>
                              <Label for="desc">Client's background</Label>
                              <Input type="textarea" name="Description" id='desc'  maxlength='32000' />
                            </FormGroup>
                            <FormGroup>
                              <Label for="yourname">Your name &amp; branch</Label>
                              <Input type='text' maxlength='255' name='LEADCF1' id='yourname' />  
                            </FormGroup>
                        </div>
                        <Button color="primary" className="submit">Submit</Button>
                    </Form>
                </Col>
            </Row>
        );
    }
}



export default connect()(Refer);







// WEBPACK FOOTER //
// ./src/Features/Refer/Refer.jsx